import React from "react";
import styled from "styled-components";
import { useExpanded } from "../../hooks/useExpanded";
import { lightThemeColors } from "../../assets/style/colors";
import { ReactComponent as DropdownIcon } from "../../assets/icons/downIcon.svg";
import { AnimatePresence, motion } from "framer-motion";

const PricingFaqDropdown = ({ title, decsription }) => {
  const [expanded, expand] = useExpanded();
  return (
    <Container>
      <DropdownElement onClick={expand}>
        <h2>{title}</h2>
        <DropdownIcon />
      </DropdownElement>
      <AnimatePresence>
        {expanded && (
          <motion.div
            initial={{ height: 0, width: "100%" }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
            transition={{ duration: 0.4 }}
            style={{ overflow: "hidden" }}
          >
            <DropdownContent>{decsription}</DropdownContent>
          </motion.div>
        )}
      </AnimatePresence>
    </Container>
  );
};

export default PricingFaqDropdown;

const Container = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  overflow: hidden;
`;

const DropdownElement = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
  justify-content: space-between;
  border-bottom: 1px solid rgba(237, 235, 234, 1);
  padding: 20px 0;
  overflow: hidden;
  svg {
    width: 20px;
    height: 10px;
  }
  h2 {
    color: ${lightThemeColors.darkColor};
    font-size: 22px;
    font-weight: 600;
    line-height: 30px;
    text-align: left;
  }

  @media (max-width: 990px) {
    h2 {
      font-size: 24px;
      line-height: 32px;
    }
  }
`;

const DropdownContent = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  padding: 0px 0;
  p {
    color: ${lightThemeColors.darkColorFaded};
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
  }
  @media (max-width: 990px) {
    gap: 18px;
  }
`;
